<!-- 文件上传 -->
<template>
  <md-field :class="{'md-error' : error}">
    <div @click="modal_file_input" :style="{'width':'100%'}">
      <slot />
    </div>
    <md-icon v-if="error">clear</md-icon>
    <input :style="{display:'none'}" type="file" ref="inputFile" @change="otherFile" />
  </md-field>
</template>
<script>
export default {
  props:{
    error: {
      type: Boolean,
      default: false,
    },
    typeFilter:{
      type: Array,
      default: () => {
        return []
      },
    },
    // sizeFilter_min:{// 文件大小(最小要求, MB)
    //   type: Number,
    //   default: 0,
    // },
    sizeFilter_max:{// 文件大小(最大要求, MB)
      type: Number,
      default: 0,
    },
    nameUseTime:{ // 用时间戳做文件名
      type:Boolean,
      default: false,
    },
  },
  data(){
    return {
      // childValue: this.value,
    }
  },
  methods:{
    modal_file_input(){ // 点击上传文件
      this.$refs.inputFile.click();
    },
    otherFile ($event) { // (file发生变化)
      this.onFileSelected($event)
    },
    onFileSelected ({ target, dataTransfer }) { // 选择文件
      const files = target.files || dataTransfer.files;
      this.getFileName(files, target);
    },
    getFileName (files, target) { // 获取文件名
      console.log(files)
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }

      if(this.typeFilter.length > 0){
        const typeName = files[0].name.split(".").pop();
        if(!files[0].name.includes(".") || !this.typeFilter.includes(typeName)){
          this.$errorMsg(this.$I18n("error_file_type").replace("XXX", this.typeFilter.join("','")))
          return files[0].name
        }
      }
      if(this.sizeFilter_max > 0 && files[0].size > this.sizeFilter_max * 1024 * 1024){
        this.$errorMsg(this.$I18n("error_file_size_b").replace("XXX", this.sizeFilter_max))
        return files[0].name
      }
      if (files.length > 1) {
        return this.getMultipleName(files)
      }

      if (files.length === 1) {
        this.$emit("change","",files[0].name);
        var fileObj = files[0];
        if(this.nameUseTime){
          fileObj = new File(
            [files[0]],
            new Date().getTime()+ "." +files[0].name.split(".").pop(),
            {type: files[0].type}
          )
        }
        this.$api.uploadFile_PUT({
          file: fileObj, 
        })
          .then(this.$Then(res => {
            this.$emit("change",res.data.get_url, fileObj.name);
          }))
          .catch(this.$Catch(this.$I18n("file_error"), () => {
            this.$emit("change","", fileObj.name);
          }))
        return fileObj.name
      }

      return null
    },
  },
}
</script>